export default __webpack_public_path__ + "static/media/faq-ellipse-left.aaaadddd.svg";